import classNames from 'styles/utils/classNames';

interface Props {
  label: string;
  /** Appended after a brand dot — "Wed • 6 – 8 PM", "Sevier Park • 5mi". */
  detail?: string;
  /** `sm` = Figma "Badge Button" (26px); `md` = the detail modals' 32px pills. */
  size?: 'sm' | 'md';
  className?: string;
}

/** The grey "label • detail" pill used for availability slots and preferred courts. */
export default function DotChip({ label, detail, size = 'sm', className }: Props) {
  return (
    <span
      className={classNames(
        'flex max-w-full items-center gap-ds-xs rounded-full bg-color-bg-lightmode-secondary text-color-text-lightmode-primary dark:bg-color-bg-darkmode-secondary dark:text-color-text-darkmode-primary',
        size === 'sm'
          ? 'typography-product-button-label-small h-[1.625rem] px-ds-sm'
          : 'typography-product-button-label-medium px-ds-md py-ds-sm',
        className,
      )}
    >
      <span className="truncate">{label}</span>
      {detail && (
        <>
          <span className="text-color-text-brand">•</span>
          <span className="shrink-0">{detail}</span>
        </>
      )}
    </span>
  );
}
